__webpack_require__.p = "/product-updates-reload-notification/referrals-hub/";